import React from 'react';
import { SyncOutlined } from '@ant-design/icons';

const buttonType = {
  primary:
    'bg-blue-500 text-white border-none hover:bg-blue-600 hover:text-white',
  secondary:
    'bg-[#F0F6FE] text-[#2E51CD] border-none hover:bg-[#dae8fa] hover:text-[#2E51CD]',
  outline: 'bg-white border border-[#D0D5DD] text-[#344054] hover:bg-[#F9FAFB]',
  error:
    'bg-[#F04438] text-white border-none hover:bg-[#f04438ee] hover:text-white',
};

const buttonSize = {
  xs: '',
  sm: 'min-h-10 py-1 px-3 text-base',
  base: 'py-2 md:py-2 px-5 md:px-6 text-sm md:text-base',
  md: '',
  lg: '',
};

const CustomButton = ({
  onClick,
  disabled = false,
  icon,
  isLoading = false,
  size = 'base',
  type = 'primary',
  className = '',
  children,
}) => {
  const isDisabled = disabled || isLoading;

  const handleClick = (e) => {
    if (isDisabled) return;
    onClick?.(e);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      className={`select-none flex flex-nowrap text-nowrap justify-center items-center gap-2 rounded-md ${buttonSize[size]} ${buttonType[type]} ${className}`}
    >
      {isLoading ? (
        <span className="flex items-center justify-center">
          <SyncOutlined spin />
        </span>
      ) : (
        icon && <span className="flex items-center justify-center">{icon}</span>
      )}
      {children}
    </button>
  );
};

export default CustomButton;
